import { OrganizationTeamResponseDto, OrganizationTeamWithMembersResponseDto } from 'app/API';
import TeamTag from './TeamTag';

type StateSetter<T> = (newValue: T | ((prevValue: T) => T)) => void;

type TeamForFilter = OrganizationTeamResponseDto | OrganizationTeamWithMembersResponseDto;

type TeamsFilterProps = {
  teamsFilterValues: TeamForFilter[];
  chosenTeamsFilter: string[];
  setChosenTeamsFilter: StateSetter<any>;
  isOrganizationTeams?: boolean;
};

export default function TeamsFilter({
  teamsFilterValues = [],
  chosenTeamsFilter = [],
  setChosenTeamsFilter,
  isOrganizationTeams = false,
}: TeamsFilterProps) {
  return teamsFilterValues.length ? (
    <>
      <p
        className="teams-assigned-filter"
        style={{
          fontWeight: '600',
          fontSize: '12px',
          lineHeight: '150%',
          color: 'var(--color-text-muted)',
          padding: '20px 0 10px',
        }}
      >
        Teams assigned to {isOrganizationTeams ? 'organization' : 'workspace'}
      </p>
      <div className="workspace-teams-filter flex flex-wrap gap-1.5">
        <TeamTag
          customStyle={{
            backgroundColor: chosenTeamsFilter.length ? '' : 'var(--color-surface-muted)',
            color: 'var(--color-text)',
            opacity: '1',
            margin: '0',
          }}
          onClick={() => setChosenTeamsFilter([])}
          team={{ name: 'All' }}
        />

        {teamsFilterValues.map((team) => (
          <TeamTag
            key={team.slug}
            customStyle={{
              margin: '0',
            }}
            active={!chosenTeamsFilter.length || chosenTeamsFilter.includes(team.slug)}
            onClick={() =>
              setChosenTeamsFilter((prev: string[]) =>
                !prev.includes(team.slug) ? [...prev, team.slug] : [...prev.filter((value) => value !== team.slug)],
              )
            }
            team={team}
          />
        ))}
      </div>
    </>
  ) : null;
}
